export default __webpack_public_path__ + "static/media/07.1518d6c0.png";